import React, { Component } from 'react';

/*import TextField from './Fields/TextField';
import EmailField from './Fields/EmailField';
import NumberField from './Fields/NumberField';
import CheckBox from './Fields/CheckBox';
import Radio from './Fields/Radio';
import Textarea from './Fields/Textarea';
import Dropdown from './Fields/Dropdown';*/
import Wrp from '../../hoc/Wrp/Wrp';
import { 
	TextField, 
	EmailField, 
	NumberField, 
	CheckBox, 
	Radio, 
	Textarea, 
	Dropdown ,
	PasswordField,
	DropDownWithSearch,
	MultiSelect,
	Status
} from './Fields';

class Inputs extends Component {

	/*shouldComponentUpdate(nextProps, nextState) {
		console.log(this.props.displayFormCont);
		// console.log(this.props.state);
		return true;
	}*/

	/*componentDidUpdate() {
		console.log("componentDidUpdate");
		setTimeout(function () {
			if(this.state.incVal == 0 ) {
				const updateState = { ...this.props };
				updateState.displayFormCont = "asdfasdfdf";
				updateState.incVal = this.state.incVal + 1;
				this.setState(updateState);
			}
		}.bind(this), 2000);
	}*/

	/*componentDidMount() {
		console.log("componentDidMount");
		setTimeout(
			function(){ 
				const updateState = { ...this.state };
				updateState.displayFormCont = "wwpoda";
				this.setState(updateState);
			}.bind(this), 2000);
	}*/


	render() {
		let dispFormCont = null;
		let formData = JSON.parse(this.props.formData);
		switch(formData.field) {
			case 'text' :
				dispFormCont = <TextField keyDownHandler={this.props.keyDownHandler} fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed} onblur={this.props.onblur}/>;
				break;
			case 'email' :
				dispFormCont = <EmailField fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'number' :
				dispFormCont = <NumberField fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'checkbox' :
				dispFormCont = <CheckBox fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'radio' :
				dispFormCont = <Radio fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'textarea' :
				dispFormCont = <Textarea {...this.props} fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'select' :
				dispFormCont = <Dropdown fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'password' :
				dispFormCont = <PasswordField keyDownHandler={this.props.keyDownHandler}  fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'select2' :
				dispFormCont = <DropDownWithSearch fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'multiselect' :
				dispFormCont = <MultiSelect fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			case 'status' :
				dispFormCont = <Status fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed}/>;
				break;
			default :
				dispFormCont = <TextField keyDownHandler={this.props.keyDownHandler} fieldKey={this.props.fieldName} fieldDetails={this.props.formData} changed={this.props.changed} onblur={this.props.onblur}/>;
		}
		return (
			<Wrp>
				{this.props.formFields}
				{/*this.state.displayFormCont*/}
				{dispFormCont}
			</Wrp>
		);
	}
}

export default Inputs;